import React from 'react';
import { motion } from 'framer-motion';
import { CheckSquare } from 'lucide-react';
export function BonusValue() {
  const items = [{
    label: 'Lo que llevas hoy',
    text: 'Libro principal',
    price: '$57',
    strikethrough: '$57',
    free: false
  }, {
    label: 'Bono #1',
    text: 'El Guion Anti-Culpa',
    price: '$17',
    strikethrough: '$17',
    free: true
  }, {
    label: 'Bono #2',
    text: 'Plantilla Reparto Sin Pleito',
    price: '$17',
    strikethrough: '$17',
    free: true
  }, {
    label: 'Bono #3',
    text: 'Checklist Semana de Aire',
    price: '$13',
    strikethrough: '$13',
    free: true
  }];
  return <section className="py-6 px-4 bg-white" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-6" data-id="element-94">
          {/* Value anchor table */}
          <div className="bg-cream border border-navy/10 rounded-xl overflow-hidden shadow-sm text-left" data-id="element-95">
            {items.map((item, index) => <div key={index} className="flex items-center justify-between px-5 py-4 border-b border-navy/8 last:border-b-0" data-id="element-96">
                <span className="text-navy/60 text-sm w-32 shrink-0" data-id="element-97">
                  {item.label}
                </span>
                <div className="flex items-center gap-2 flex-1" data-id="element-98">
                  <CheckSquare className="w-5 h-5 text-sage shrink-0" aria-hidden="true" data-id="element-99" />
                  <span className="text-navy font-medium" data-id="element-100">
                    {item.text}
                    {item.free ? <span data-id="element-101">
                        {' '}
                        —{' '}
                        <span className="line-through text-navy/40" data-id="element-102">
                          {item.strikethrough}
                        </span>{' '}
                        <span className="text-sage font-semibold" data-id="element-103">Gratis</span>
                      </span> : <span data-id="element-104">
                        {' '}
                        —{' '}
                        <span className="line-through text-navy/40" data-id="element-105">
                          {item.price}
                        </span>
                      </span>}
                  </span>
                </div>
              </div>)}

            {/* Total row */}
            <div className="flex items-center justify-between px-5 py-4 border-t border-navy/10 bg-navy/3" data-id="element-106">
              <span className="text-navy/60 text-sm w-32 shrink-0" data-id="element-107">
                Total real
              </span>
              <span className="text-navy/50 line-through font-medium flex-1 pl-7" data-id="element-108">
                Valor total: $104.00
              </span>
            </div>

            {/* Price today row */}
            <div className="flex items-center justify-between px-5 py-5 bg-terracotta/10" data-id="element-109">
              <span className="text-navy/60 text-sm w-32 shrink-0" data-id="element-110">
                Precio hoy
              </span>
              <span className="text-navy font-bold text-xl flex-1 pl-7 text-center" data-id="element-111">
                Hoy lo llevas todo por{' '}
                <span className="text-black text-3xl" data-id="element-112">$6.39</span>
              </span>
            </div>
          </div>

          <div className="bg-cream border border-terracotta/20 rounded-xl px-6 py-5 text-center max-w-xl mx-auto" data-id="element-113">
            <p className="text-xl md:text-2xl font-serif font-bold text-navy" data-id="element-114">
              Garantía de 7 días — Sin Culpa.
            </p>
            <p className="text-base md:text-lg text-navy/70 mt-2" data-id="element-115">
              Si este libro no te da alivio o claridad, te devuelvo tu dinero
              sin preguntas.
            </p>
          </div>

          <p className="text-2xl md:text-3xl font-serif font-bold text-navy" data-id="element-116">
            Estos 3 bonos se venden juntos por $47.
          </p>
          <p className="text-2xl md:text-3xl font-serif font-bold text-terracotta" data-id="element-117">
            Hoy los recibes completamente gratis cuando te llevas el libro.
          </p>
          <div className="max-w-2xl mx-auto space-y-3 pt-2" data-id="element-118">
            <p className="text-lg text-navy/80 leading-relaxed" data-id="element-119">
              No porque valgan poco. Sino porque lo que más me importa es que
              tengas todo lo que necesitas para empezar esta semana.
            </p>
            <p className="text-lg text-navy/80 leading-relaxed" data-id="element-120">
              Una frase para usar hoy con quien más te drena. Una plantilla para
              repartir esta semana sin pelear. Un plan para recuperar aire en 7
              días.
            </p>
            <p className="text-lg font-semibold text-navy pt-2" data-id="element-121">
              Sin esperar. Sin excusas. Sin más culpa.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}